<template>
  <button :class="classList" @click.prevent="btnFunction">
    {{ btnTitle }}
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    btnTitle: String,
    classList: String,
    btnFunction: Function,
  },
};
</script>

<style lang="scss" scoped>
.btn {
  display: inline-block;
  font-size: 12px;
}
button {
  padding: 10px;
  width: 150px;
  border-radius: 20px;
  background-color: #232323;
  color: #fff;
}
  button:hover{
    cursor: pointer;
  }
</style>
